module.exports = __webpack_public_path__ + "img/sports-globalbet.e7bf7b7c.png";